// 引用axios
import {
  Message,
  Loading,
} from 'element-ui'; // 引入elm组件
import axios from 'axios';
import router from '@/router';
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(obj) {
  const o = obj;
  const keys = Object.keys(obj);
  keys.map((key) => {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key]);
    }
    return key;
  });
  return o;
}
/**
 *
 *
 * @param {any} method 方法
 * @param {any} url 地址
 * @param {any} data 实体类body
 * @param {any} params url数据
 * @param {any} success 正确回调
 * @param {any} failure 错误回调
 */
function apiAxiosLogin(method, urlIn, data, paramsIn, success, failure) {
  const url = urlIn;
  let params = paramsIn;
  if (params && typeof params !== 'string') {
    params = filterNull(params);
  }
  axios({
    method: 'POST',
    url,
    data: data || null,
    params: params || null,
    withCredentials: false,
    headers: {
      'X-HTTP-Method-Override': method === 'postG' ? 'get' : '',
      'Content-Type': 'application/json',
      // 'Access-Token': localStorage.getItem('store'),
      // selfcookie: 'JSESSIONID=D2250B1D4223C4E85F45DC8466975859',
    },
  })
    .then((resOut) => {
      const res = resOut;
      if (res.status === 204) {
        res.data = {
          message: '成功',
        };
      }
      success(res);
    })
    .catch((err) => {
      if (failure) {
        failure(err);
      }
    });
}
function apiAxios(method, urlIn, data, paramsIn, success, failure) {
  const url = urlIn;
  let params = paramsIn;
  if (params && typeof params !== 'string') {
    params = filterNull(params);
  }
  params['t'] = new Date().valueOf();
  return axios({
    method: method === 'postG' ? 'POST' : method,
    url,
    data: data || null,
    params: params || null,
    withCredentials: false,
    headers: {
      'X-HTTP-Method-Override': method === 'postG' ? 'get' : '',
      'Content-Type': 'application/json',
      'Access-Token': localStorage.getItem('store'),
      // selfcookie: 'JSESSIONID=D2250B1D4223C4E85F45DC8466975859',
    },
  })
    .then((resOut) => {
      const res = resOut;
      if (res.status === 204) {
        res.data = {
          message: '成功',
        };
      }
      return success(res);
    })
    .catch((err) => {
      if (failure) {
        failure(err);
      }
    });
}

/**
 *
 * 下载的接口
 * @param {any} method 方法
 * @param {any} url 地址
 * @param {any} data 实体类body
 * @param {any} params url数据
 * @param {any} success 正确回调
 * @param {any} failure 错误回调
 */
function apiAxiosDownload(method, url, data, paramsIn, success, failure) {
  let params = paramsIn;
  if (params && typeof params !== 'string') {
    params = filterNull(params);
  }
  axios({
    method: 'POST',
    url,
    // baseURL: global.configUrl1,
    data: data || null,
    params: params || null,
    responseType: 'blob',
    withCredentials: false,
  })
    .then((res) => {
      // console.log(res);
      success(res);
    })
    .catch((err) => {
      if (failure) {
        failure(err);
      }
    });
}
function getDownload(url, data, paramsIn, success, failure) {
  let params = paramsIn;
  if (params && typeof params !== 'string') {
    params = filterNull(params);
  }
  axios({
    method: 'GET',
    url,
    // baseURL: global.configUrl1,
    data: data || null,
    params: params || null,
    responseType: 'blob',
    withCredentials: false,
    headers: {
      'X-HTTP-Method-Override': 'get',
      'Content-Type': 'application/json',
      'Access-Token': localStorage.getItem('store'),
    },
  })
    .then((res) => {
      // console.log(res);
      success(res);
    })
    .catch((err) => {
      if (failure) {
        failure(err);
      }
    });
}
// 返回在vue模板中的调用接口
export default {
  // get请求
  get(url, data, params, success, failure) {
    return apiAxios('GET', url, data, params, success, failure);
  },
  // post请求
  post(url, data, params, success, failure) {
    return apiAxios('POST', url, data, params, success, failure);
  },
  // post请求
  postLogin(url, data, params, success, failure) {
    return apiAxiosLogin('POST', url, data, params, success, failure);
  },
  // patch请求
  patch(url, data, params, success, failure) {
    return apiAxios('PATCH', url, data, params, success, failure);
  },
  // put请求
  put(url, data, params, success, failure) {
    return apiAxios('PUT', url, data, params, success, failure);
  },
  // delete
  delete(url, data, params, success, failure) {
    return apiAxios('DELETE', url, data, params, success, failure);
  },
  // 增加 postG请求 按后台要求 get请求在某些情况 需要传实体body so 添加postG请求
  postG(url, data, params, postdata, success, failure) {
    return apiAxios('postG', url, data, params, success, failure);
  },
  // 下载的请求接口
  postDownload(url, data, params, success, failure) {
    return apiAxiosDownload('postG', url, data, params, success, failure);
  },
  getDownload(url, data, params, success, failure) {
    return getDownload(url, data, params, success, failure);
  },
};
// 添加一个请求拦截器
// axios.interceptors.request.use(
//   (configIn) => {
//     const config = configIn;
//     // 为了解决 promise.all的 多个参数 无法计算遮罩 增加遮罩计数器 by--刘春阳 徐速成
//     if (config.url !== '/api/v1/mxgl/getfx') { // 轮询接口不要全局loading，否则闪屏
//       if (modelIndex === 0) {
//         // console.log('蒙层显示');
//         loadingInstance = Loading.service({
//           lock: true,
//           text: '处理中...',
//           background: 'rgba(0, 0, 0, 0.7)',
//         });
//       }
//       modelIndex = modelIndex + 1;
//     }
//     // config.headers.common['token'] = store.getters.getCookie // 每次发送之前 从vuex拿token携带
//     // config.headers.common['User-Info'] = store.getters.getUserInfo // 将用户信息等数据 放到header中发给后台 by--绍奎涛
//     if (config.method === 'post' || config.method === 'postG') {
//       // 发现ie下有从缓存拿数据的bug 所以在所有请求加上时间戳 by--刘春阳
//       // config.data = {
//       //   ...config.data,
//       //   _t: Date.parse(new Date()) / 1000
//       // }
//     } else {
//       config.params = {
//         _t: Date.parse(new Date()) / 1000,
//         ...config.params,
//       };
//     }
//     return config;
//   },
//   error => Promise.reject(error),
// );
// // 添加一个响应拦截器
// axios.interceptors.response.use(
//   (response) => {
//     const res = response;
//     closeLoding();
//     // 与后台沟通 204没有实体类 但前台需要实体类用以 promise回调 so 我们自己搞 按照各业务 可以删除或修改
//     if (res.status === 204) {
//       res.data = {
//         content: [],
//       };
//     }
//     if (res.data.code === 3008) {
//       localStorage.clear();
//       router.replace('/login');
//     }
//     return res;
//   },
//   (err) => {
//     closeLoding();
//     let errMsg = '';
//     if (err && err.response.status) {
//       switch (err.response.status) {
//         case 401:
//           errMsg = '登录状态失效，请重新登录';
//           // window.location.reload();
//           localStorage.clear();
//           // localStorage.removeItem('tsToken')
//           router.replace('/login');
//           break;
//         case 403:
//           errMsg = '拒绝访问';
//           break;
//         case 408:
//           errMsg = '请求超时';
//           break;
//         case 500:
//           errMsg = '服务器网络错误，请稍后再试';
//           break;
//         case 501:
//           errMsg = '服务未实现';
//           break;
//         case 502:
//           errMsg = '网关错误';
//           break;
//         case 503:
//           errMsg = '服务不可用';
//           break;
//         case 504:
//           errMsg = '网关超时';
//           break;
//         case 505:
//           errMsg = 'HTTP版本不受支持';
//           break;
//         default:
//           errMsg = err.response.data.message;
//           break;
//       }
//     } else {
//       errMsg = err;
//     }
//     // 上报日志
//     // if (Vue.prototype.aegis) {
//     //   Vue.prototype.aegisaegis.report(new Error(errMsg));
//     // }
//     Message.error(errMsg);
//     return Promise.reject(err);
//   },
// );

// function closeLoding() {
//   if (modelIndex > 0) {
//     modelIndex = modelIndex - 1;
//   }
//   if (modelIndex === 0) {
//     if (loadingInstance) {
//       loadingInstance.close();
//     }
//   }
// }



// WEBPACK FOOTER //
// ./src/package/axios.js